<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ f4562Header.ATTRIB_DESCRIPTION }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Body with tabs -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id; onTabChange(tab.name)" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Input Details Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>
          <!-- Entity info display (matching AngularJS structure) -->
          <div class="row" style="padding-bottom: 0 !important;">
            <div class="container-fluid">
              @if (!isExamScenario) {
<div class="row">
                <div class="col-md-6">
                  <div class="col-md-1">
                    <span class="LayerLine1">Entity:</span>
                  </div>
                  <div class="col-md-10">
                    <span class="LayerData1 ng-binding">{{ rowData.LEID }} : {{ rowData.LE_NAME }} : {{ rowData.TAX_YEAR_BEGIN }} - {{ rowData.TAX_YEAR_END }}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="col-md-2">
                    <span class="LayerLine1">Business:</span>
                  </div>
                  <div class="col-md-9">
                    <span class="LayerData1 ng-binding">{{ rowData.ME_CODE }} - {{ rowData.ME_NAME }}</span>
                  </div>
                </div>
                <div class="col-md-2">
                  <span class="LayerLine1">Tax Code:</span>
                  <span class="LayerData1 ng-binding">{{ rowData.CDR_NO }}</span>
                </div>
              </div>
}
              
              @if (isExamScenario) {
<div class="row">
                <div class="col-md-4">
                  <div class="col-md-2">
                    <span class="LayerLine1">Entity:</span>
                  </div>
                  <div class="col-md-10">
                    <span class="LayerData1">
                      {{rowData.LEID}} : {{rowData.LE_NAME}} : {{rowData.TAX_YEAR_BEGIN}} - {{rowData.TAX_YEAR_END}}
                    </span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="col-md-3">
                    <span class="LayerLine1">Business:</span>
                  </div>
                  <div class="col-md-9">
                    <span class="LayerData1">{{rowData.ME_CODE}} - {{rowData.ME_NAME}}</span>
                  </div>
                </div>
                <div class="col-md-2">
                  <span class="LayerLine1">Tax Code:</span>
                  <span class="LayerData1">{{rowData.CDR_NO}}</span>
                </div>
                <div class="col-md-3">
                  <span class="LayerLine1">Issue: {{rowData.ISSUE_KEY}}</span>
                </div>
              </div>
}
            </div>
          </div>

        <!-- Form Header -->
        <table class="InnerTblBG custom-table" style="width: 100%; border: 0px;">
          <tbody>
            <tr>
              <th class="BlackSmHdrBC">
                <h4>{{f4562Header.ATTRIB_DESCRIPTION}}</h4>
              </th>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>

        <!-- Form Description -->
        <table class="InnerTblBG custom-table" style="width: 100%; border: 0px;">
          <tbody>
            <tr>
              <td style="width: 3px;">
                <i class="fa fa-info-circle" style="font-size:24px;color:skyblue"></i>
              </td>
              <td class="BlackTxtBL">
                {{f4562Header.ATTRIB_DESCRIPTION}}
              </td>
            </tr>
          </tbody>
        </table>

          <div class="form-table-scroll-wrapper">
          <table class="table table-bordered form-inline InnerTblBG custom-table">
            @for (row of f4562FormData; track $index; let mainIndex = $index) {
              @if (hasVisibleRowContent(row)) {
<tr>
              <!-- TH Row Type -->
              <!--
                A `TH` (Total Header) row is a horizontal layout of cells where
                the leading cell(s) carry the human-readable label (e.g.
                "Total Depreciation Expense Per Tax Return", "Unallocated
                Amount") and the trailing cell carries the numeric total. The
                label cells arrive from the backend with DATA_TYPE='string',
                ATTRIB_VALUE = the label text. The numeric cells arrive with
                DATA_TYPE='number', ATTRIB_VALUE = the value, and DESCRIPTION
                set to a tag that the controller uses to identify special
                totals (currently only 'Unallocated Amount' for the red/green
                signaling).

                Previously every cell was piped through `numberWithCommas`,
                which returns '' for non-numeric strings, so the label cells
                rendered as empty and only the totals were visible (QA
                reported "missing labels in the first column"). We now branch
                on DATA_TYPE: string -> raw label, number -> formatted total.
              -->
              @if (row.ROW_TYPE==='TH') {

                @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td 
                    style="font-weight: bold;" 
                    [attr.align]="item.COL_CLASS" 
                    [attr.colspan]="item.COLSPAN"
                    [ngClass]="{'color-red': item.DATA_TYPE === 'number' && item.ATTRIB_VALUE < 0}">
                    <!-- String label cell (left side of the totals row) -->
                    @if (item.DATA_TYPE === 'string') {
<p>
                      {{ item.ATTRIB_VALUE }}
                    </p>
}
                    <!-- Numeric total: red when Unallocated Amount is non-zero -->
                    @if (item.DATA_TYPE !== 'string' && item.DESCRIPTION === 'Unallocated Amount' && unAllocatedAmt !== 0) {
<p style="color:red;">
                      {{item.ATTRIB_VALUE | numberWithCommas}}
                    </p>
}
                    <!-- Numeric total: green when Unallocated Amount is zero (fully allocated) -->
                    @if (item.DATA_TYPE !== 'string' && item.DESCRIPTION === 'Unallocated Amount' && unAllocatedAmt === 0) {
<p style="color:green;">
                      {{item.ATTRIB_VALUE | numberWithCommas}}
                    </p>
}
                    <!-- Plain numeric total (all other rows) -->
                    @if (item.DATA_TYPE !== 'string' && item.DESCRIPTION !== 'Unallocated Amount') {
<p>
                      {{item.ATTRIB_VALUE | numberWithCommas}}
                    </p>
}
                </td>
}
              
}
              
              <!-- PH Row Type -->
              @if (row.ROW_TYPE==='PH') {
<td style="font-weight: bold;" colspan="10">
                {{ row.Line_data[0]?.ATTRIB_VALUE }}
              </td>
}
              
              <!-- DT Row Type -->
              @if (row.ROW_TYPE==='DT') {

                @for (item of row.Line_data; track $index; let itemIndex = $index) {

                  <!-- Skip td for non-first consecutive labeled checkboxes (e.g. Lease/Charter after Own on line 24c) -->
                  @if (!(item.ATTRIB_DESCRIPTION !== 'NA' && item.ATTRIB_DESCRIPTION !== 'Yes' && (item.EDIT_TYPE==='checkbox'||item.EDIT_TYPE==='radio') && row.Line_data[itemIndex-1]?.ATTRIB_DESCRIPTION !== 'NA' && row.Line_data[itemIndex-1]?.ATTRIB_DESCRIPTION !== 'Yes' && (row.Line_data[itemIndex-1]?.EDIT_TYPE==='checkbox'||row.Line_data[itemIndex-1]?.EDIT_TYPE==='radio'))) {
<td [attr.colspan]="item.COLSPAN">
                    @if (item.EDIT_TYPE==='currency' && item.DATA_TYPE==='number') {
<p>
                      <input [(ngModel)]="item.ATTRIB_VALUE" 
                             class="form-control input-md numText" 
                             type="text"
                             onlyDigitsDecimal
                             (ngModelChange)="onCurrencyAmountChange(mainIndex, itemIndex, item.LINE_NO)"
                             [disabled]="item.IS_EDITABLE==='N'">
                    </p>
}
                    @if ((item.EDIT_TYPE==='checkbox' || item.EDIT_TYPE==='radio') && item.DATA_TYPE==='string') {
<p>
                      @if (item.ATTRIB_DESCRIPTION === 'NA') {
<input 
                             type="checkbox" class="form-control"
                             [checked]="item.ATTRIB_VALUE === 'Y'" 
                             (change)="onCheckboxChange(item, mainIndex, item.LINE_NO, itemIndex, $event)">
}
                      @if (item.ATTRIB_DESCRIPTION === 'Yes') {
<span>
                        <input type="checkbox" class="form-control"
                               [name]="'checkbox_' + mainIndex + '_' + item.LINE_NO" 
                               [value]="'Y'" 
                               [checked]="item.ATTRIB_VALUE === 'Y'" 
                               (change)="item.ATTRIB_VALUE = 'Y'; valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"> Yes
                        <input type="checkbox" class="form-control"
                               [name]="'checkbox_' + mainIndex + '_' + item.LINE_NO" 
                               [value]="'N'" 
                               [checked]="item.ATTRIB_VALUE === 'N'" 
                               (change)="item.ATTRIB_VALUE = 'N'; valuechanged(mainIndex, null, item.LINE_NO, itemIndex)"> No
                      </span>
}
                      <!-- Labeled checkbox (e.g. Own for 24c): also renders the next sibling items inline in the same span -->
                      @if (item.ATTRIB_DESCRIPTION !== 'NA' && item.ATTRIB_DESCRIPTION !== 'Yes') {
<span>
                        <input type="checkbox" class="form-control"
                               [checked]="item.ATTRIB_VALUE === 'Y'"
                               (change)="onCheckboxChange(item, mainIndex, item.LINE_NO, itemIndex, $event)"> {{item.ATTRIB_DESCRIPTION}}
                        @if (row.Line_data[itemIndex+1]?.ATTRIB_DESCRIPTION !== 'NA' && row.Line_data[itemIndex+1]?.ATTRIB_DESCRIPTION !== 'Yes' && (row.Line_data[itemIndex+1]?.EDIT_TYPE==='checkbox'||row.Line_data[itemIndex+1]?.EDIT_TYPE==='radio')) {

                          <input type="checkbox" class="form-control"
                                 [checked]="row.Line_data[itemIndex+1].ATTRIB_VALUE === 'Y'"
                                 (change)="onCheckboxChange(row.Line_data[itemIndex+1], mainIndex, row.Line_data[itemIndex+1].LINE_NO, itemIndex+1, $event)"> {{row.Line_data[itemIndex+1].ATTRIB_DESCRIPTION}}
                        
}
                        @if (row.Line_data[itemIndex+2]?.ATTRIB_DESCRIPTION !== 'NA' && row.Line_data[itemIndex+2]?.ATTRIB_DESCRIPTION !== 'Yes' && (row.Line_data[itemIndex+2]?.EDIT_TYPE==='checkbox'||row.Line_data[itemIndex+2]?.EDIT_TYPE==='radio')) {

                          <input type="checkbox" class="form-control"
                                 [checked]="row.Line_data[itemIndex+2].ATTRIB_VALUE === 'Y'"
                                 (change)="onCheckboxChange(row.Line_data[itemIndex+2], mainIndex, row.Line_data[itemIndex+2].LINE_NO, itemIndex+2, $event)"> {{row.Line_data[itemIndex+2].ATTRIB_DESCRIPTION}}
                        
}
                      </span>
}
                    </p>
}
                    @if (item.EDIT_TYPE==='label' && item.DATA_TYPE==='string') {
<p>{{ item.ATTRIB_VALUE }}</p>
}
                  </td>
}
                
}
              
}
              
              <!-- RT Row Type -->
              @if (row.ROW_TYPE==='RT') {

                @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td [attr.colspan]="item.COLSPAN">
                  @if (item.EDIT_TYPE==='radio' && item.DATA_TYPE==='string' && item.ATTRIB_SHORT_CODE && item.ATTRIB_SHORT_CODE.indexOf('ASSETS_PLACED') !== -1) {
<p>
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'assets_placed_' + mainIndex + '_' + itemIndex" 
                           value="Yes" 
                           (ngModelChange)="valuechanged(mainIndex, item.OCCURRENCE, item.LINE_NO, itemIndex)"> Yes
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'assets_placed_' + mainIndex + '_' + itemIndex" 
                           value="No" 
                           (ngModelChange)="valuechanged(mainIndex, item.OCCURRENCE, item.LINE_NO, itemIndex)"> No
                  </p>
}
                  @if (item.EDIT_TYPE==='radio' && item.DATA_TYPE==='string' && item.ATTRIB_SHORT_CODE && item.ATTRIB_SHORT_CODE.indexOf('BONUS_APPLIED') !== -1) {
<p>
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'bonus_applied_' + mainIndex + '_' + itemIndex" 
                           value="Bonus" 
                           (ngModelChange)="valuechanged(mainIndex, item.OCCURRENCE, item.LINE_NO, itemIndex)"> Bonus
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'bonus_applied_' + mainIndex + '_' + itemIndex" 
                           value="NonBonus" 
                           (ngModelChange)="valuechanged(mainIndex, item.OCCURRENCE, item.LINE_NO, itemIndex)"> Non Bonus
                  </p>
}
                  @if (item.EDIT_TYPE==='radio' && item.DATA_TYPE==='string' && item.ATTRIB_SHORT_CODE && item.ATTRIB_SHORT_CODE.indexOf('IDENTIFY_METHOD') !== -1) {
<p>
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'identify_method_' + mainIndex + '_' + itemIndex" 
                           value="Macrs" 
                           (ngModelChange)="valuechanged(mainIndex, item.OCCURRENCE, item.LINE_NO, itemIndex)"> MACRS
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'identify_method_' + mainIndex + '_' + itemIndex" 
                           value="SL" 
                           (ngModelChange)="valuechanged(mainIndex, item.OCCURRENCE, item.LINE_NO, itemIndex)"> SL
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'identify_method_' + mainIndex + '_' + itemIndex" 
                           value="Book" 
                           (ngModelChange)="valuechanged(mainIndex, item.OCCURRENCE, item.LINE_NO, itemIndex)"> Book
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'identify_method_' + mainIndex + '_' + itemIndex" 
                           value="Other" 
                           (ngModelChange)="valuechanged(mainIndex, item.OCCURRENCE, item.LINE_NO, itemIndex)"> Other
                  </p>
}
                  @if (item.EDIT_TYPE==='label' && item.DATA_TYPE==='string') {
<p>{{ item.ATTRIB_VALUE }}</p>
}
                </td>
}
              
}
              
              <!-- CH Row Type (Complex nested table) -->
              @if (row.ROW_TYPE==='CH') {
<td colspan="10" class="ch-table-cell">
                <div class="table-scroll-wrapper">
                  <table class="table table-bordered form-inline InnerTblBG custom-table">
                  @for (item of row.Line_data; track $index; let itemIndex = $index) {
<tr>
                    @if (item.Line_Type==='HEADER_ROW') {

                      @for (column of item.Line_data_occ; track $index) {
<th>
                        @if (column.ATTRIB_DESCRIPTION != 'Comments') {
<p>{{ column.ATTRIB_VALUE }}</p>
}
                      </th>
}
                    
}
                    @if (item.Line_Type==='SUB_ROW') {
<td>
                      {{ item.Line_no }}
                      <i class="fa fa-plus-circle color-green fa-lg pull-right"
                         style="cursor: pointer; margin-top: 4px;"
                         title="Add Details"
                         aria-label="Add details"
                         role="button"
                         tabindex="0"
                         (click)="AddNewRow(item.Line_no)"
                         (keydown.enter)="AddNewRow(item.Line_no)"
                         (keydown.space)="AddNewRow(item.Line_no); $event.preventDefault()">
                      </i>
                    </td>
}
                    @if (item.Line_Type==='SUB_ROW') {
<td colspan="9">Add Details</td>
}
                    @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {
<td>
                      <i class="fa fa-pencil bluepencil pull-left"
                         style="cursor: pointer; margin-top: 4px;"
                         title="Edit Details"
                         aria-label="Edit details"
                         role="button"
                         tabindex="0"
                         (click)="editExistingRecord(item.Line_no, item.Occurrence, itemIndex)"
                         (keydown.enter)="editExistingRecord(item.Line_no, item.Occurrence, itemIndex)"
                         (keydown.space)="editExistingRecord(item.Line_no, item.Occurrence, itemIndex); $event.preventDefault()">
                      </i>
                      <i class="fa fa-minus-circle color-red fa-lg pull-right"
                         style="cursor: pointer; margin-top: 4px;"
                         title="Remove Details"
                         aria-label="Remove details"
                         role="button"
                         tabindex="0"
                         (click)="removeExistingRecord(item.Line_no, item.Occurrence, itemIndex)"
                         (keydown.enter)="removeExistingRecord(item.Line_no, item.Occurrence, itemIndex)"
                         (keydown.space)="removeExistingRecord(item.Line_no, item.Occurrence, itemIndex); $event.preventDefault()">
                      </i>
                    </td>
}
                    @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {

                      @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length); track $index; let colIndex = $index) {
<td>
                      @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.DATA_TYPE == 'number') {
<p 
                         [ngClass]="{'color-red': column.ATTRIB_VALUE < 0}">
                        {{ column.ATTRIB_VALUE | numberWithCommas }}
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.DATA_TYPE != 'number') {
<p>
                        {{ column.ATTRIB_VALUE }}
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      </td>
}
                    
}
                    
                    <!-- Data Comments Row -->
                    @if (item.Line_Type==='DATA_COMMENTS' && item.Is_Multi==='Y') {
<td style="text-align: left !important" colspan="2">
                      <h4 style="font-weight: bold;">{{ item.Line_data_occ[0]?.ATTRIB_DESCRIPTION }}:</h4>
                    </td>
}
                    @if (item.Line_Type==='DATA_COMMENTS' && item.Is_Multi==='Y') {
<td colspan="8">
                      {{ item.Line_data_occ[0]?.ATTRIB_VALUE }}
                    </td>
}
                    
                    @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {
<td>
                      <i class="fa fa-check-circle color-green fa-lg pull-left"
                         style="cursor: pointer; margin-top: 4px;"
                         title="Save Details"
                         aria-label="Save details"
                         role="button"
                         tabindex="0"
                         (click)="saveNewEdittedRecord(item.Line_no, item.Occurrence, itemIndex)"
                         (keydown.enter)="saveNewEdittedRecord(item.Line_no, item.Occurrence, itemIndex)"
                         (keydown.space)="saveNewEdittedRecord(item.Line_no, item.Occurrence, itemIndex); $event.preventDefault()">
                      </i>
                      <i class="fa fa-minus-circle color-red fa-lg pull-right"
                         style="cursor: pointer; margin-top: 4px;"
                         title="Remove Details"
                         aria-label="Remove details"
                         role="button"
                         tabindex="0"
                         (click)="removeExistingRecord(item.Line_no, item.Occurrence, itemIndex)"
                         (keydown.enter)="removeExistingRecord(item.Line_no, item.Occurrence, itemIndex)"
                         (keydown.space)="removeExistingRecord(item.Line_no, item.Occurrence, itemIndex); $event.preventDefault()">
                      </i>
                    </td>
}
                    @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {

                      @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length); track $index; let colIndex = $index) {
<td>
                      @if (column.EDIT_TYPE==='label' && column.DATA_TYPE==='number') {
<p>{{ column.ATTRIB_VALUE }}</p>
}
                      @if (column.EDIT_TYPE==='radio' && column.DATA_TYPE==='string') {
<p>
                        <input type="radio" class="radio-inline"
                               [(ngModel)]="column.ATTRIB_VALUE" 
                               [name]="'perm_temp_' + mainIndex + '_' + itemIndex + '_' + colIndex" 
                               value="Perm" 
                               (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"> Perm
                        <input type="radio" class="radio-inline"
                               [(ngModel)]="column.ATTRIB_VALUE" 
                               [name]="'perm_temp_' + mainIndex + '_' + itemIndex + '_' + colIndex" 
                               value="Temp" 
                               (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"> Temp
                      </p>
}
                      @if (column.EDIT_TYPE==='text' && column.DATA_TYPE==='string') {
<p>
                        <textarea style="width: 100%"
                                  class="form-control input-sm numText"
                                  [(ngModel)]="column.ATTRIB_VALUE"
                                  placeholder="<-- Description -->"
                                  (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex)">
                        </textarea>
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      @if (column.EDIT_TYPE==='currency' && column.DATA_TYPE==='number') {
<p>
                        <input [(ngModel)]="column.ATTRIB_VALUE" 
                               class="form-control input-md numText" 
                               type="text"
                               onlyDigitsDecimal
                               (ngModelChange)="onCurrencyAmountChange(mainIndex, itemIndex, column.LINE_NO, undefined, column.OCCURRENCE, colIndex)">
                      </p>
}
                      @if (column.EDIT_TYPE==='checkbox' && column.DATA_TYPE==='string') {
<p>
                        <input type="checkbox" class="form-control"
                               [checked]="column.ATTRIB_VALUE === 'Y'" 
                               (change)="onCheckboxChangeColumn(column, mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, $event)">
                      </p>
}
                      @if (column.EDIT_TYPE==='custom_date_various' && column.DATA_TYPE==='dateVarious') {
<div class="form-inline" style="white-space: nowrap; min-width: 150px;">
                        <div class="form-group" style="margin: 0">
                          <input type="checkbox" 
                                 [checked]="column.ATTRIB_VALUE === 'VARIOUS'" 
                                 (change)="onDateVariousCheckboxChange(column, mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, $event)"
                                 title="Various"
                                 style="margin-right: 5px;">
                        </div>
                        <div class="form-group" style="margin: 0">
                          @if (column.ATTRIB_VALUE !== 'VARIOUS') {
<input 
                                 type="date" 
                                 class="form-control"
                                 [(ngModel)]="column.ATTRIB_VALUE" 
                                 (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"
                                 style="min-width: 150px;">
}
                          @if (column.ATTRIB_VALUE === 'VARIOUS') {
<input 
                                 type="text" 
                                 class="form-control" 
                                 value="VARIOUS" 
                                 disabled
                                 style="min-width: 150px;">
}
                        </div>
                      </div>
}
                      @if (column.EDIT_TYPE === 'select' && column.DATA_TYPE === 'string' && column.ATTRIB_SHORT_CODE.indexOf('RECOVERY_PERIOD') !== -1) {
<p>
                        <select [(ngModel)]="column.ATTRIB_VALUE" class="form-control"
                                (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"
                                [disabled]="column.IS_EDITABLE_CELL == 'N'">
                          @for (recoveryPeriod of recoveryPeriod; track $index) {
<option [value]="recoveryPeriod">
                            {{ recoveryPeriod }}
                          </option>
}
                        </select>
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      @if (column.EDIT_TYPE === 'multi_select' && column.DATA_TYPE === 'string' && column.ATTRIB_SHORT_CODE.indexOf('METHOD_OR_CONVENTION') !== -1) {
<p>
                        <select [(ngModel)]="column.ATTRIB_VALUE_METHOD" class="form-control"
                                (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"
                                [disabled]="column.IS_EDITABLE_CELL == 'N'">
                          @for (method of methods; track $index) {
<option [value]="method">{{ method }}</option>
}
                        </select>
                        <select [(ngModel)]="column.ATTRIB_VALUE_CONVENTION" class="form-control"
                                (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"
                                [disabled]="column.IS_EDITABLE_CELL == 'N'">
                          @for (convension of convensions; track $index) {
<option [value]="convension">{{ convension }}</option>
}
                        </select>
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      @if (column.EDIT_TYPE === 'select_text' && column.DATA_TYPE === 'string' && column.ATTRIB_SHORT_CODE.indexOf('AMORTIZATION_PERIOD_OR_PTG') !== -1) {
<p>
                        <select [(ngModel)]="column.ATTRIB_VALUE_PERIOD" class="form-control"
                                (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex)"
                                [disabled]="column.IS_EDITABLE_CELL == 'N'">
                          @for (recoveryPeriod of recoveryPeriod; track $index) {
<option [value]="recoveryPeriod">
                            {{ recoveryPeriod }}
                          </option>
}
                        </select> OR
                        <input [(ngModel)]="column.ATTRIB_VALUE_PERCENTAGE"
                               class="form-control input-md numText" 
                               type="text"
                               onlyDigitsDecimal
                               (ngModelChange)="onCurrencyAmountChange(mainIndex, itemIndex, column.LINE_NO, undefined, column.OCCURRENCE, colIndex)">
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      </td>
}
                    
}
                  </tr>
}
                </table>
                </div>
              </td>
}
              
              <!-- LH Row Type (Similar structure to CH but different data source) -->
              @if (row.ROW_TYPE==='LH') {
<td colspan="10" class="lh-table-cell">
                <div class="table-scroll-wrapper lh-table-scroll-wrapper">
                <table class="table table-bordered form-inline InnerTblBG custom-table lh-nested-table" style="border: 1px solid #ddd">
                  <colgroup>
                    <col class="lh-col-line-no">
                    <col class="lh-col-classification">
                    <col class="lh-col-date">
                    <col class="lh-col-basis">
                    <col class="lh-col-recovery">
                    <col class="lh-col-convention">
                    <col class="lh-col-method">
                    <col class="lh-col-deduction">
                  </colgroup>
                  <tbody>
                    @for (item of row.Line_data; track $index; let rowIndex = $index) {
<tr>
                     @for (dataItem of item.Line_data; track getLhCellTrackKey(dataItem, $index); let dataItemIndex = $index) {
<td [attr.colspan]="getLhCellColspan(dataItem, item.Line_data) || null"
    [class.RedHdrTbl]="dataItem.ATTRIB_SHORT_CODE?.includes('HEADER')">
                        @if (dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('HEADER') !== -1) {
<p>{{ getHeaderCellText(dataItem) }}</p>
}
                        @if (dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('HEADER') === -1) {
<span>
                          
                          @if (dataItem.EDIT_TYPE === 'label' && dataItem.DATA_TYPE === 'string') {
<p>
                            {{ dataItem.ATTRIB_VALUE || dataItem.ATTRIB_DESCRIPTION }}
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'currency' && dataItem.DATA_TYPE === 'number') {
<p>
                            <input [(ngModel)]="dataItem.ATTRIB_VALUE" 
                                   class="form-control input-md numText" 
                                   type="text"
                                   onlyDigitsDecimal
                                   (ngModelChange)="onCurrencyAmountChange(mainIndex, dataItemIndex, dataItem.LINE_NO, rowIndex, null, dataItemIndex, rowIndex)">
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'text' && dataItem.DATA_TYPE === 'string' && dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('RECOVERY') === -1) {
<p>
                            <input [(ngModel)]="dataItem.ATTRIB_VALUE" 
                                   type="text" 
                                   class="form-control"
                                   (ngModelChange)="valuechanged(rowIndex, null, dataItem.LINE_NO, dataItemIndex)" 
                                   [disabled]="dataItem.IS_EDITABLE_CELL === 'N'">
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'text' && dataItem.DATA_TYPE === 'string' && dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('RECOVERY') !== -1 && dataItem.IS_EDITABLE_CELL !== 'N') {
<p>
                            <input [(ngModel)]="dataItem.ATTRIB_VALUE" 
                                   type="text" 
                                   class="form-control"
                                   (ngModelChange)="valuechanged(rowIndex, null, dataItem.LINE_NO, dataItemIndex)">
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'text' && dataItem.DATA_TYPE === 'string' && dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('RECOVERY') !== -1 && dataItem.IS_EDITABLE_CELL === 'N') {
<p>{{ dataItem.ATTRIB_DESCRIPTION || dataItem.ATTRIB_VALUE }}</p>
}
                          @if (dataItem.EDIT_TYPE === 'custom_date_various' && dataItem.DATA_TYPE === 'dateVarious') {
<div class="form-inline" style="white-space: nowrap; min-width: 150px;">
                            <div class="form-group" style="margin: 0">
                              <input type="checkbox"
                                     [checked]="dataItem.ATTRIB_VALUE === 'VARIOUS'"
                                     (change)="onDateVariousCheckboxChange(dataItem, mainIndex, null, dataItem.LINE_NO, dataItemIndex, $event)"
                                     title="Various"
                                     style="margin-right: 5px;">
                            </div>
                            <div class="form-group" style="margin: 0">
                              @if (dataItem.ATTRIB_VALUE !== 'VARIOUS') {
<input type="date"
                                     class="form-control"
                                     [(ngModel)]="dataItem.ATTRIB_VALUE"
                                     (ngModelChange)="valuechanged(rowIndex, null, dataItem.LINE_NO, dataItemIndex)"
                                     style="min-width: 150px;">
}
                              @if (dataItem.ATTRIB_VALUE === 'VARIOUS') {
<input type="text"
                                     class="form-control"
                                     value="VARIOUS"
                                     disabled
                                     style="min-width: 150px;">
}
                            </div>
                          </div>
}
                          @if (dataItem.EDIT_TYPE === 'select' && dataItem.DATA_TYPE === 'string' && dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('RECOVERY_PERIOD') !== -1) {
<p>
                            <select class="form-control"
                                    [(ngModel)]="dataItem.ATTRIB_VALUE"
                                    (ngModelChange)="valuechanged(rowIndex, null, dataItem.LINE_NO, dataItemIndex)"
                                    [disabled]="dataItem.IS_EDITABLE_CELL == 'N'">
                              @for (recovery of recoveryPeriod; track $index) {
<option [value]="recovery">{{ recovery }}</option>
}
                            </select>
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'select' && dataItem.DATA_TYPE === 'string' && !(dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('RECOVERY_PERIOD') !== -1)) {
<p>
                            @if (dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('CONVENTION') !== -1) {
<select
                                    class="form-control"
                                    [(ngModel)]="dataItem.ATTRIB_VALUE"
                                    (ngModelChange)="valuechanged(rowIndex, null, dataItem.LINE_NO, dataItemIndex)"
                                    [disabled]="dataItem.IS_EDITABLE_CELL == 'N'">
                              @for (convension of convensions; track $index) {
<option [value]="convension">{{ convension }}</option>
}
                            </select>
}
                            @if (dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('METHOD') !== -1) {
<select
                                    class="form-control"
                                    [(ngModel)]="dataItem.ATTRIB_VALUE"
                                    (ngModelChange)="valuechanged(rowIndex, null, dataItem.LINE_NO, dataItemIndex)"
                                    [disabled]="dataItem.IS_EDITABLE_CELL == 'N'">
                              @for (method of methods; track $index) {
<option [value]="method">{{ method }}</option>
}
                            </select>
}
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'multi_select' && dataItem.DATA_TYPE === 'string' && dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('METHOD_OR_CONVENTION') !== -1) {
<p>
                            <select [(ngModel)]="dataItem.ATTRIB_VALUE_METHOD" class="form-control"
                                    (ngModelChange)="valuechanged(rowIndex, null, dataItem.LINE_NO, dataItemIndex)"
                                    [disabled]="dataItem.IS_EDITABLE_CELL == 'N'">
                              @for (method of methods; track $index) {
<option [value]="method">{{ method }}</option>
}
                            </select>
                            <select [(ngModel)]="dataItem.ATTRIB_VALUE_CONVENTION" class="form-control"
                                    (ngModelChange)="valuechanged(rowIndex, null, dataItem.LINE_NO, dataItemIndex)"
                                    [disabled]="dataItem.IS_EDITABLE_CELL == 'N'">
                              @for (convension of convensions; track $index) {
<option [value]="convension">{{ convension }}</option>
}
                            </select>
                          </p>
}
                         </span>
}
                     </td>
}
                    </tr>
}
                  </tbody>
                </table>
                </div>
              </td>
}
            </tr>
              }
}
          </table>
          </div>
        </div>
}
      </div>
    </div>
}
    
    <!-- FACS Details Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>
          <!-- Entity Information Header (same as Input Details) -->
          <table style="width: 100%; border: 0px; cellspacing: 0; cellpadding: 0;">
            <tbody>
              <tr>
                <td class="LayerLine2" nowrap>Entity:</td>
                <td class="LayerData1" nowrap>{{ rowData.LEID }} : {{ rowData.LE_NAME }} : {{ rowData.TAX_YEAR_BEGIN }} - {{ rowData.TAX_YEAR_END }}</td>
                <td class="LayerLine2" nowrap>Business:</td>
                <td class="LayerData1" nowrap>{{ rowData.ME_CODE }} - {{ rowData.ME_NAME }}</td>
                <td class="LayerLine2" nowrap>Tax Code:</td>
                <td class="LayerData1" nowrap>{{ rowData.CDR_NO }}</td>
                <td class="LayerLine2" nowrap>Reporting Period:</td>
                <td class="LayerData1" nowrap>{{ rowData.REPORTING_PERIOD }}</td>
              </tr>
            </tbody>
          </table>

          <!-- FACS Header Title -->
          <table class="InnerTblBG" style="width: 100%; border: 0px; cellspacing: 0; cellpadding: 0; font-weight: bold;">
            <tbody>
              <tr>
                <th class="BlackSmHdrBC">
                  <h4>{{ f4562FACSHeader.ATTRIB_DESCRIPTION }}</h4>
                </th>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>

          <!-- FACS Header Description with Icon -->
          <table class="InnerTblBG" style="width: 100%; border: 0px; cellspacing: 0; cellpadding: 0">
            <tbody>
              <tr>
                <td style="width: 3px;">
                  <i class="fa fa-info-circle" style="font-size: 24px; color: skyblue"></i>
                </td>
                <td class="BlackTxtBL">
                  {{ f4562FACSHeader.ATTRIB_DESCRIPTION }}
                </td>
              </tr>
            </tbody>
          </table>

          <!-- FACS Form Data (Read-only) -->
          <div class="form-table-scroll-wrapper">
          <table class="table table-bordered form-inline InnerTblBG custom-table">
            @for (row of f4562FACSFormData; track $index; let mainIndex = $index) {
              @if (hasVisibleRowContent(row)) {
<tr>
              
              <!-- TH Row Type -->
              <!-- See the explanatory comment on the Input Details TH block
                   above — same structure (string label cell + numeric total
                   cell), same fix to render string labels without the
                   numberWithCommas pipe so the leading column isn't blank. -->
              @if (row.ROW_TYPE==='TH') {

                @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td 
                    style="font-weight: bold;" 
                    [attr.align]="item.COL_CLASS" 
                    [attr.colspan]="item.COLSPAN"
                    [ngClass]="{'color-red': item.DATA_TYPE === 'number' && item.ATTRIB_VALUE < 0}">
                  <!-- String label cell (left side of the totals row) -->
                  @if (item.DATA_TYPE === 'string') {
<p>
                    {{ item.ATTRIB_VALUE }}
                  </p>
}
                  <!-- Numeric total: red when Unallocated Amount is non-zero -->
                  @if (item.DATA_TYPE !== 'string' && item.DESCRIPTION === 'Unallocated Amount' && unAllocatedAmt !== 0) {
<p style="color: red;">
                    {{ item.ATTRIB_VALUE | numberWithCommas }}
                  </p>
}
                  <!-- Numeric total: green when Unallocated Amount is zero (fully allocated) -->
                  @if (item.DATA_TYPE !== 'string' && item.DESCRIPTION === 'Unallocated Amount' && unAllocatedAmt === 0) {
<p style="color: green;">
                    {{ item.ATTRIB_VALUE | numberWithCommas }}
                  </p>
}
                  <!-- Plain numeric total (all other rows) -->
                  @if (item.DATA_TYPE !== 'string' && item.DESCRIPTION !== 'Unallocated Amount') {
<p>
                    {{ item.ATTRIB_VALUE | numberWithCommas }}
                  </p>
}
                </td>
}
              
}
              
              <!-- PH Row Type -->
              @if (row.ROW_TYPE==='PH') {
<td style="font-weight: bold;" colspan="10">
                {{ row.Line_data[0]?.ATTRIB_VALUE }}
              </td>
}
              
              <!-- DT Row Type (Disabled inputs) -->
              @if (row.ROW_TYPE==='DT') {

                @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td [attr.colspan]="item.COLSPAN">
                  @if (item.EDIT_TYPE==='currency' && item.DATA_TYPE==='number') {
<p>
                    <input [(ngModel)]="item.ATTRIB_VALUE" 
                           class="form-control input-md numText" 
                           type="text" 
                           disabled>
                  </p>
}
                  @if (item.EDIT_TYPE==='label' && item.DATA_TYPE==='string') {
<p>{{ item.ATTRIB_VALUE }}</p>
}
                </td>
}
              
}

              <!-- RT Row Type (Read-only radio buttons) -->
              @if (row.ROW_TYPE==='RT') {

                @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td [attr.colspan]="item.COLSPAN">
                  @if (item.EDIT_TYPE==='radio' && item.DATA_TYPE==='string' && item.ATTRIB_SHORT_CODE && item.ATTRIB_SHORT_CODE.indexOf('ASSETS_PLACED') !== -1) {
<p>
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'assets_placed_facs_' + mainIndex + '_' + itemIndex" 
                           value="Yes" disabled> Yes
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'assets_placed_facs_' + mainIndex + '_' + itemIndex" 
                           value="No" disabled> No
                  </p>
}
                  @if (item.EDIT_TYPE==='radio' && item.DATA_TYPE==='string' && item.ATTRIB_SHORT_CODE && item.ATTRIB_SHORT_CODE.indexOf('BONUS_APPLIED') !== -1) {
<p>
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'bonus_applied_facs_' + mainIndex + '_' + itemIndex" 
                           value="Bonus" disabled> Bonus
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'bonus_applied_facs_' + mainIndex + '_' + itemIndex" 
                           value="NonBonus" disabled> Non Bonus
                  </p>
}
                  @if (item.EDIT_TYPE==='radio' && item.DATA_TYPE==='string' && item.ATTRIB_SHORT_CODE && item.ATTRIB_SHORT_CODE.indexOf('IDENTIFY_METHOD') !== -1) {
<p>
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'identify_method_facs_' + mainIndex + '_' + itemIndex" 
                           value="Macrs" disabled> MACRS
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'identify_method_facs_' + mainIndex + '_' + itemIndex" 
                           value="SL" disabled> SL
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'identify_method_facs_' + mainIndex + '_' + itemIndex" 
                           value="Book" disabled> Book
                    <input type="radio" class="radio-inline"
                           [(ngModel)]="item.ATTRIB_VALUE" 
                           [name]="'identify_method_facs_' + mainIndex + '_' + itemIndex" 
                           value="Other" disabled> Other
                  </p>
}
                  @if (item.EDIT_TYPE==='label' && item.DATA_TYPE==='string') {
<p>{{ item.ATTRIB_VALUE }}</p>
}
                </td>
}
              
}
              
              <!-- LH Row Type (All fields disabled) -->
              @if (row.ROW_TYPE==='LH') {
<td colspan="10" class="lh-table-cell">
                <div class="table-scroll-wrapper lh-table-scroll-wrapper">
                <table class="table table-bordered form-inline InnerTblBG custom-table lh-nested-table" style="border: 1px solid #ddd">
                  <colgroup>
                    <col class="lh-col-line-no">
                    <col class="lh-col-classification">
                    <col class="lh-col-date">
                    <col class="lh-col-basis">
                    <col class="lh-col-recovery">
                    <col class="lh-col-convention">
                    <col class="lh-col-method">
                    <col class="lh-col-deduction">
                  </colgroup>
                  <tbody>
                    @for (item of row.Line_data; track $index; let rowIndex = $index) {
<tr>
                     @for (dataItem of item.Line_data; track getLhCellTrackKey(dataItem, $index); let dataItemIndex = $index) {
<td [attr.colspan]="getLhCellColspan(dataItem, item.Line_data) || null"
    [class.RedHdrTbl]="dataItem.ATTRIB_SHORT_CODE?.includes('HEADER')">
                        @if (dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('HEADER') !== -1) {
<p>{{ getHeaderCellText(dataItem) }}</p>
}
                        @if (dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('HEADER') === -1) {
<span>
                          @if (dataItem.EDIT_TYPE === 'label' && dataItem.DATA_TYPE === 'string') {
<p>
                            {{ dataItem.ATTRIB_VALUE || dataItem.ATTRIB_DESCRIPTION }}
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'currency' && dataItem.DATA_TYPE === 'number') {
<p>
                            <input [(ngModel)]="dataItem.ATTRIB_VALUE" 
                                   class="form-control input-md numText" 
                                   type="text" disabled>
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'text' && dataItem.DATA_TYPE === 'string' && dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('RECOVERY') === -1) {
<p>
                            <input [(ngModel)]="dataItem.ATTRIB_VALUE" class="form-control"
                                   type="text" disabled>
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'text' && dataItem.DATA_TYPE === 'string' && dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('RECOVERY') !== -1 && dataItem.IS_EDITABLE_CELL !== 'N') {
<p>
                            <input [(ngModel)]="dataItem.ATTRIB_VALUE" class="form-control"
                                   type="text" disabled>
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'text' && dataItem.DATA_TYPE === 'string' && dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('RECOVERY') !== -1 && dataItem.IS_EDITABLE_CELL === 'N') {
<p>{{ dataItem.ATTRIB_DESCRIPTION || dataItem.ATTRIB_VALUE }}</p>
}
                          @if (dataItem.EDIT_TYPE === 'custom_date_various' && dataItem.DATA_TYPE === 'dateVarious') {
<p>{{ dataItem.ATTRIB_VALUE }}</p>
}
                          @if (dataItem.EDIT_TYPE === 'select' && dataItem.DATA_TYPE === 'string' && dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('RECOVERY_PERIOD') !== -1) {
<p>{{ dataItem.ATTRIB_VALUE }}</p>
}
                          @if (dataItem.EDIT_TYPE === 'select' && dataItem.DATA_TYPE === 'string' && !(dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('RECOVERY_PERIOD') !== -1)) {
<p>
                            @if (dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('CONVENTION') !== -1) {
<select
                                    class="form-control"
                                    [(ngModel)]="dataItem.ATTRIB_VALUE"
                                    disabled>
                              @for (convension of convensions; track $index) {
<option [value]="convension">{{ convension }}</option>
}
                            </select>
}
                            @if (dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('METHOD') !== -1) {
<select
                                    class="form-control"
                                    [(ngModel)]="dataItem.ATTRIB_VALUE"
                                    disabled>
                              @for (method of methods; track $index) {
<option [value]="method">{{ method }}</option>
}
                            </select>
}
                          </p>
}
                          @if (dataItem.EDIT_TYPE === 'multi_select' && dataItem.DATA_TYPE === 'string' && dataItem.ATTRIB_SHORT_CODE && dataItem.ATTRIB_SHORT_CODE.indexOf('METHOD_OR_CONVENTION') !== -1) {
<p>
                            {{ dataItem.ATTRIB_VALUE_METHOD }} / {{ dataItem.ATTRIB_VALUE_CONVENTION }}
                          </p>
}
                         </span>
}
                     </td>
}
                    </tr>
}
                  </tbody>
                </table>
                </div>
              </td>
}
              
              <!-- CH Row Type (Read-only, no edit icons) -->
              @if (row.ROW_TYPE==='CH') {
<td colspan="10" class="ch-table-cell">
                <div class="table-scroll-wrapper">
                  <table class="table table-bordered form-inline InnerTblBG custom-table">
                  @for (item of row.Line_data; track $index; let itemIndex = $index) {
<tr>
                    <!-- Header Row -->
                    @if (item.Line_Type==='HEADER_ROW') {

                      @for (column of item.Line_data_occ; track $index) {
<th>
                        @if (column.ATTRIB_DESCRIPTION != 'Comments') {
<p>{{ column.ATTRIB_VALUE }}</p>
}
                      </th>
}
                    
}
                    
                    <!-- Sub Row (Add Details) - No add icon -->
                    @if (item.Line_Type==='SUB_ROW') {
<td>
                      {{ item.Line_no }}
                    </td>
}
                    @if (item.Line_Type==='SUB_ROW') {
<td colspan="9">Add Details</td>
}
                    
                    <!-- Data Row (No edit/delete icons) -->
                    @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {
<td>
                      <!-- No icons in FACS Details -->
                    </td>
}
                    @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {

                      @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length); track $index; let colIndex = $index) {
<td>
                      @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.DATA_TYPE == 'number') {
<p 
                         [ngClass]="{'color-red': column.ATTRIB_VALUE < 0}">
                        {{ column.ATTRIB_VALUE | numberWithCommas }}
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.DATA_TYPE != 'number') {
<p>
                        {{ column.ATTRIB_VALUE }}
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      </td>
}
                    
}
                    
                    <!-- Data Comments Row -->
                    @if (item.Line_Type==='DATA_COMMENTS' && item.Is_Multi==='Y') {
<td style="text-align: left !important" colspan="2">
                      <h4 style="font-weight: bold;">{{ item.Line_data_occ[0].ATTRIB_DESCRIPTION }}:</h4>
                    </td>
}
                    @if (item.Line_Type==='DATA_COMMENTS' && item.Is_Multi==='Y') {
<td colspan="8">
                      {{ item.Line_data_occ[0].ATTRIB_VALUE }}
                    </td>
}
                    
                    <!-- Edit Row (No save/delete icons) -->
                    @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {
<td>
                      <!-- No icons in FACS Details -->
                    </td>
}
                    @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {

                      @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length); track $index; let colIndex = $index) {
<td>
                      @if (column.EDIT_TYPE==='label' && column.DATA_TYPE==='number') {
<p>{{ column.ATTRIB_VALUE }}</p>
}
                      @if (column.EDIT_TYPE==='radio' && column.DATA_TYPE==='string') {
<p>
                        <input type="radio" class="radio-inline"
                               [(ngModel)]="column.ATTRIB_VALUE" 
                               [name]="'perm_temp_facs_' + mainIndex + '_' + itemIndex + '_' + colIndex" 
                               value="Perm" disabled> Perm
                        <input type="radio" class="radio-inline"
                               [(ngModel)]="column.ATTRIB_VALUE" 
                               [name]="'perm_temp_facs_' + mainIndex + '_' + itemIndex + '_' + colIndex" 
                               value="Temp" disabled> Temp
                      </p>
}
                      @if (column.EDIT_TYPE==='text' && column.DATA_TYPE==='string') {
<p>
                        <textarea style="width: 100%" class="form-control"
                                  class="form-control input-sm numText"
                                  [(ngModel)]="column.ATTRIB_VALUE"
                                  placeholder="<-- Description -->"
                                  disabled>
                        </textarea>
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      @if (column.EDIT_TYPE==='currency' && column.DATA_TYPE==='number') {
<p>
                        <input [(ngModel)]="column.ATTRIB_VALUE" 
                               class="form-control input-md numText" 
                               type="text" disabled>
                      </p>
}
                      @if (column.EDIT_TYPE==='checkbox' && column.DATA_TYPE==='string') {
<p>
                        <input type="checkbox" class="form-control"
                               [checked]="column.ATTRIB_VALUE === 'Y'" disabled>
                      </p>
}
                      @if (column.EDIT_TYPE==='custom_date_various' && column.DATA_TYPE==='dateVarious') {
<div class="form-inline" style="white-space: nowrap; min-width: 150px;">
                        <div class="form-group" style="margin: 0">
                          <input type="checkbox" 
                                 [checked]="column.ATTRIB_VALUE === 'VARIOUS'" disabled
                                 title="Various"
                                 style="margin-right: 5px;">
                        </div>
                        <div class="form-group" style="margin: 0">
                          @if (column.ATTRIB_VALUE !== 'VARIOUS') {
<input 
                                 type="date" 
                                 class="form-control"
                                 [(ngModel)]="column.ATTRIB_VALUE" disabled
                                 style="min-width: 150px;">
}
                          @if (column.ATTRIB_VALUE === 'VARIOUS') {
<input 
                                 type="text" 
                                 class="form-control" 
                                 value="VARIOUS" 
                                 disabled
                                 style="min-width: 150px;">
}
                        </div>
                      </div>
}
                      @if (column.EDIT_TYPE === 'select' && column.DATA_TYPE === 'string' && column.ATTRIB_SHORT_CODE.indexOf('RECOVERY_PERIOD') !== -1) {
<p>
                        <select [(ngModel)]="column.ATTRIB_VALUE" class="form-control" disabled>
                          @for (recoveryPeriod of recoveryPeriod; track $index) {
<option [value]="recoveryPeriod">
                            {{ recoveryPeriod }}
                          </option>
}
                        </select>
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      @if (column.EDIT_TYPE === 'multi_select' && column.DATA_TYPE === 'string' && column.ATTRIB_SHORT_CODE.indexOf('METHOD_OR_CONVENTION') !== -1) {
<p>
                        <select [(ngModel)]="column.ATTRIB_VALUE_METHOD" class="form-control" disabled>
                          @for (method of methods; track $index) {
<option [value]="method">
                            {{ method }}
                          </option>
}
                        </select>
                        <select [(ngModel)]="column.ATTRIB_VALUE_CONVENTION" class="form-control" disabled>
                          @for (convension of convensions; track $index) {
<option [value]="convension">
                            {{ convension }}
                          </option>
}
                        </select>
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      @if (column.EDIT_TYPE === 'select_text' && column.DATA_TYPE === 'string' && column.ATTRIB_SHORT_CODE.indexOf('AMORTIZATION_PERIOD_OR_PTG') !== -1) {
<p>
                        <select [(ngModel)]="column.ATTRIB_VALUE_PERIOD" class="form-control" disabled>
                          @for (recoveryPeriod of recoveryPeriod; track $index) {
<option [value]="recoveryPeriod">
                            {{ recoveryPeriod }}
                          </option>
}
                        </select> OR
                        <input [(ngModel)]="column.ATTRIB_VALUE_PERCENTAGE" class="form-control"
                               class="form-control input-md numText" 
                               type="text" disabled>
                        @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                          {{ column.ATTRIB_VALUE_ERROR }}
                        </span>
}
                      </p>
}
                      </td>
}
                    
}
                  </tr>
}
                </table>
                </div>
              </td>
}
              
            </tr>
              }
}
          </table>
          </div>
        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- Standard Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'FACS Details') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked || !isValidScenario" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'FACS Details') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
